import { bookmarksApi } from 'api/endpoints/bookmarks';
import { selectableLoaded } from '../selectableDataReducer';
import { AppDispatch, GetState } from '../store';

export const getBookmarksThunk =
  () => async (dispatch: AppDispatch, _getState: GetState) => {
    const bookmarks = await bookmarksApi.getBookmarks();
    dispatch(selectableLoaded({ bookmarks }));
  };
